import formModel from './formModel';

const {
    formFieldPrevencion: {
        dni,
        sexo,
        cuit,
        premium,
        cantidadCapitas,
        numeroSolicitud,
        tipoAfiliacion
    }
} = formModel;

export default {
    [dni.name]: '',
    [sexo.name]: '1',
    [numeroSolicitud.name]: '',
    [tipoAfiliacion.name]: '0',
    [cantidadCapitas.name]: '1',
    [premium.name]: '',
    [cuit.name]: '',
};